<ng-container [formGroup]="parentForm">
  <div>
    <div class="row">
      <div class="col-12">
        <div
          class="p-field"
          [ngClass]="{
            'has-error': !bankName?.valid && (submitted || bankName?.touched)
          }"
        >
          <label for="bankName">Bank Name</label><br />
          <input
            appTrimInput
            id="bankName"
            name="bankName"
            formControlName="bankName"
            type="text"
            class="form-control ui-inputtext"
            (focus)="$event.target.select()"
            data-testid="billinginfobankname"
          />
          @if (submitted || bankName?.touched) {
            <div>
              @if (bankName.errors?.required || bankName.errors?.whitespace) {
                <div class="help-block">Required field</div>
              }
            </div>
          }
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div
          class="p-field"
        >
          <label for="bankAccountType">Bank Account Type</label><br />
          <rw-single-select
            id="bankAccountType"
            [items]="accountTypes"
            bindLabel="label"
            bindValue="value"
            arialabel="billing information bank account select"
            datapendoid="billinginformation-bankaccount-select"
            datatestid="billinginformation-bankaccount-select"
            name="bankAccountType"
            formControlName="bankAccountType">
          </rw-single-select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div
          class="p-field"
          [ngClass]="{
            'has-error': !bankAccountHolderName?.valid && (submitted || bankAccountHolderName?.touched)
          }"
        >
          <label for="bankAccountHolderName">Bank Account Holder Name</label><br />
          <input
            appTrimInput
            id="bankAccountHolderName"
            name="bankAccountHolderName"
            formControlName="bankAccountHolderName"
            type="text"
            class="form-control ui-inputtext"
            (focus)="$event.target.select()"
            maxlength="70"
            data-testid="billinginfoaccountholdername"
          />
          @if (submitted || bankAccountHolderName?.touched) {
            <div>
              @if (bankAccountHolderName.errors?.required || bankAccountHolderName.errors?.whitespace) {
                <div class="help-block">Required field</div>
              }
            </div>
          }
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div
          class="p-field"
          [ngClass]="{
            'has-error':
              (!bankAccountRoutingNumber?.valid) &&
              (submitted || bankAccountRoutingNumber?.touched)
          }"
        >
          <label for="bankAccountRoutingNumber">Bank Account Routing Number</label><br />
          <input
            id="bankAccountRoutingNumber"
            name="bankAccountRoutingNumber"
            formControlName="bankAccountRoutingNumber"
            maxlength="9"
            (focus)="$event.target.select()"
            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
            class="form-control ui-inputtext"
            data-testid="billinginforoutingnumber"
          />
          @if (submitted || bankAccountRoutingNumber?.touched) {
            <div>
              @if (bankAccountRoutingNumber.errors?.required || bankAccountRoutingNumber.errors?.whitespace) {
                <div class="help-block">Required field</div>
              }
              @if (!bankAccountRoutingNumber.errors?.required &&
              (bankAccountRoutingNumber.errors?.minlength.actualLength < bankAccountRoutingNumber.errors?.minlength.requiredLength)) {
                <div class="help-block">Must be 9 digits</div>
              }
            </div>
          }
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div
          class="p-field"
          [ngClass]="{
            'has-error': !bankAccountNumber?.valid && (submitted || bankAccountNumber?.touched)
          }"
        >
          <label for="bankAccountNumber">Bank Account Number</label><br />
          <input
            id="bankAccountNumber"
            name="bankAccountNumber"
            formControlName="bankAccountNumber"
            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
            class="form-control ui-inputtext"
            (focus)="$event.target.select()"
            data-testid="billinginfoaccountnumber"
          />
          @if (submitted || bankAccountNumber?.touched) {
            <div>
              @if (bankAccountNumber.errors?.required || bankAccountNumber.errors?.whitespace) {
                <div class="help-block">Required field</div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</ng-container>
